module.exports = __webpack_public_path__ + "img/gc_country_flag_lu.10ef19e1.svg";